import { memo, useEffect, useState } from "react";
import { SelectInput, useDataProvider } from "react-admin";

interface IBusScheduleByBusSchedulePlanInput {
  studentId?: number;
  schoolId?: number;
  source: string;
  alwaysOn?: boolean;
  label: string;
  validate?: any;
  allowEmpty?: boolean;
}

const BusScheduleByBusSchedulePlanInput = ({
  studentId,
  schoolId,
  source,
  alwaysOn,
  label,
  validate,
  allowEmpty,
}: IBusScheduleByBusSchedulePlanInput) => {
  const [busSchedulePlans, setBusSchedulePlans] = useState<IBusSchedulePlans[]>(
    []
  );
  const [busScheduleIds, setBusScheduleIds] = useState<number[]>([]);
  const [selectChoices, setSelectChoices] = useState<any>([]);

  const provider = useDataProvider();
  useEffect(() => {
    provider
      .getList("busSchedulePlans", {
        filter: { StudentId: Number(studentId), SchoolId: Number(schoolId) },
        pagination: {
          page: 1,
          perPage: 1000,
        },
        sort: {
          field: "Id",
          order: "ASC",
        },
      })
      .then((result) => {
        setBusSchedulePlans(result.data as IBusSchedulePlans[]);
        setBusScheduleIds([]);
        setSelectChoices([]);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentId, schoolId]);

  useEffect(() => {
    if (busSchedulePlans.length > 0) {
      let tempBusScheduleIds: number[] = [];
      busSchedulePlans.forEach((busSchedulePlan: IBusSchedulePlans) =>
        tempBusScheduleIds.push(busSchedulePlan.busScheduleId)
      );

      setBusScheduleIds((value) => [...value, ...tempBusScheduleIds]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busSchedulePlans]);

  useEffect(() => {
    if (busScheduleIds.length === 0) {
      setSelectChoices([]);
      return;
    }

    if (busScheduleIds.length === busSchedulePlans.length) {
      provider
        .getMany("busSchedules", { ids: busScheduleIds })
        .then(({ data }) => {
          busSchedulePlans.forEach((busSchedulePlan: any) => {
            data.forEach((busSchedule) => {
              if (busSchedulePlan.busScheduleId === busSchedule.id) {
                busSchedulePlan.waveName = busSchedule.name;
              }
            });
          });

          setSelectChoices(busSchedulePlans);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busScheduleIds]);

  return (
    <SelectInput
      choices={selectChoices}
      source={source}
      label={label}
      optionText="waveName"
      validate={validate}
      alwaysOn={alwaysOn}
      allowEmpty={allowEmpty}
    />
  );
};

export default memo(BusScheduleByBusSchedulePlanInput);
